import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadBusinessCategory() {
  yield takeEvery(actionTypes.LOAD_BUSINESS_CATEGORY, function* (action) {
    try {
      const response = yield API.loadBusinessCategory(action.data);
      if (response.data.success) {
        yield put(actions.loadBusinessCategorySuccess(response.data.data));
      } else {
        // console.log(
        //   "Warning: Fail to load business category. \n" + response.data.message
        // );
        yield put(actions.loadBusinessCategoryFail());
      }
    } catch (error) {
      //   console.log(
      //     "Error: Fail to load business category. \n" + API.constructErrMsg(error)
      //   );
      yield put(actions.loadBusinessCategoryFail());
    }
  });
}

export default function* businessCategorySaga() {
  yield all([fork(loadBusinessCategory)]);
}
